import { StaticModal, createModal } from '@nexelem/modals';
import { Button } from '@nexelem/components';
import { useCustomTranslation } from '../../../../../hooks';
import { useCustomToast } from '@nexelem/snackbar';
import { Trans } from 'react-i18next';
import { TaskView } from '@nexelem/graphne-api';

type RemoveTaskModalProps = {
  task: TaskView;
  onRemove: () => void;
};

export const RemoveTaskModal = ({ task, onRemove }: RemoveTaskModalProps) => {
  const { tWrapper } = useCustomTranslation('products.simulationPlan');
  const displayToast = useCustomToast();
  const productCode = task.productDetails?.code?.split(' ')?.[0] ?? '-';

  const handleConfirm = () => {
    closeRemoveTaskModal();
    onRemove();

    displayToast({
      toastType: 'info',
      message: (
        <Trans components={{ strong: <strong /> }}>{tWrapper('removeModalSuccess', { taskName: task.name })}</Trans>
      ),
    });
  };

  return (
    <StaticModal component="form" maxWidth="lg" onClose={closeRemoveTaskModal}>
      <StaticModal.Header withCloseButton>{tWrapper('removeModalTitle')}</StaticModal.Header>
      <StaticModal.Content className="flex flex-col gap-6">
        <div className="flex items-center justify-between rounded-xs border border-border-container bg-surface-container-lighter px-4 py-3">
          <div className="flex flex-col gap-1 text-s11-sb">
            <p className="inline-flex gap-2 uppercase">
              <span>{tWrapper('removeModalProductId')}</span>
              <span>{productCode}</span>
            </p>
            <span className="text-s16-sb">{task.productDetails.name}</span>
            <p className="inline-flex gap-2 uppercase">
              <span>{tWrapper('removeModalLotId')}</span>
              <span>{task.name}</span>
            </p>
          </div>
          <p className="inline-flex items-center gap-2">
            <span className="text-s16-sb">{task.progress.totalAmount.amount}</span>
            <span className="text-s16">{task.progress.totalAmount.unit.name}</span>
          </p>
        </div>
        <span className="text-s18">{tWrapper('removeModalContent')}</span>
      </StaticModal.Content>
      <StaticModal.Footer>
        <Button variant="outlined" onClick={handleConfirm}>
          {tWrapper('simulationRemove')}
        </Button>
        <Button variant="contained" onClick={closeRemoveTaskModal}>
          {tWrapper('simulationCancel')}
        </Button>
      </StaticModal.Footer>
    </StaticModal>
  );
};

export const { openRemoveTaskModal, closeRemoveTaskModal } = createModal(RemoveTaskModal, {
  name: 'RemoveTaskModal',
});
